import { useCallback } from 'react';
import { t } from '~/components/I18n/i18n';
import envelope from '~/components/Icon/envelope.png';
import { Confirm, ConfirmProps } from '~/components/Modal/Confirm/Confirm';

import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';

export type SmsVerificationPopupProps = ConfirmProps & {
  walletSmsUri: string;
};

export const SmsVerificationPopup = ({
  walletSmsUri,
  description = t('citizen_sms_verification_popup_desc'),
  onConfirm: confirm,
  ...props
}: SmsVerificationPopupProps) => {
  const { open: openViewer } = useEmbeddedViewer();

  const onConfirm = useCallback(
    (e) => {
      openViewer(walletSmsUri);
      confirm?.(e);
    },
    [confirm, openViewer, walletSmsUri]
  );
  return (
    <Confirm
      {...props}
      icon={<img src={envelope} height={100} width={100} alt="sms verification" />}
      title={t('citizen_sms_verification_popup_title')}
      description={description}
      confirmText={t('citizen_sms_verification_popup_confirm')}
      dismissText={t('citizen_button_title_next_time')}
      onConfirm={onConfirm}
      // data-event="impression"
      // data-event-category="sms_verification_popup"
      // data-event-impression_id="{category}"
    />
  );
};
